import { useEffect } from "react";

const useMetaTitle = (title: string): void => {
  useEffect(() => {
    const oldTitle = document.title;
    document.title = title;

    return () => {
      document.title = oldTitle;
    };
  }, [title]);
};

export default useMetaTitle;
